// extracted by mini-css-extract-plugin
export var content = "Layout-module--content--74c59";
export var fullWidthBg = "Layout-module--fullWidthBg--f039e";
export var header = "Layout-module--header--84abd";
export var headerWrapper = "Layout-module--header-wrapper--533e1";
export var headerWrapperHidden = "Layout-module--header-wrapper--hidden--037d0";
export var header__btnMobileMenu = "Layout-module--header__btnMobileMenu--04290";
export var header__button = "Layout-module--header__button--df09e";
export var header__logo = "Layout-module--header__logo--cd3a3";
export var layout = "Layout-module--layout--3181b";